"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var GwsGameProvidersEditor_1 = require("./component/GwsGameProvidersEditor");
var GwsGameProvidersList_1 = require("./component/GwsGameProvidersList");
var GwsGameProviderGamesList_1 = require("./component/GwsGameProviderGamesList");
var GwsGameProviderCfgEditor_1 = require("./component/GwsGameProviderCfgEditor");
var GwsGameProviderAdminsAccessList_1 = require("./component/GwsGameProviderAdminsAccessList");
var GwsGameProviderZonesList_1 = require("./component/GwsGameProviderZonesList");
var GwsGameProviderZonesEditor_1 = require("./component/GwsGameProviderZonesEditor");
var PGwsGameProvidersList = /** @class */ (function (_super) {
    __extends(PGwsGameProvidersList, _super);
    function PGwsGameProvidersList(props) {
        return _super.call(this, props) || this;
    }
    PGwsGameProvidersList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            rootRecord: null,
            zoneRecord: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize()
        });
    };
    PGwsGameProvidersList.prototype.componentWillUnmount = function () {
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PGwsGameProvidersList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", rootRecord: null });
    };
    PGwsGameProvidersList.prototype.onEditClick = function (id) {
        this.setState({ edit_mode: "EDIT", rootRecord: id });
    };
    PGwsGameProvidersList.prototype.onVewGamesClick = function (id) {
        this.setState({ edit_mode: "VIEW-GAMES", rootRecord: id });
    };
    PGwsGameProvidersList.prototype.onVewZonesClick = function (id) {
        this.setState({ edit_mode: "ZONES-LIST", rootRecord: id });
    };
    PGwsGameProvidersList.prototype.onConfigClick = function (id) {
        this.setState({ edit_mode: "CONFIG", rootRecord: id });
    };
    PGwsGameProvidersList.prototype.onAccessConfigClick = function (id) {
        this.setState({ edit_mode: "ACCESS-CONFIG", rootRecord: id });
    };
    PGwsGameProvidersList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", rootRecord: null });
    };
    PGwsGameProvidersList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PGwsGameProvidersList.prototype.onNewZoneRecordClick = function () {
        this.setState({ edit_mode: "ZONES-NEW", zoneRecord: null });
    };
    PGwsGameProvidersList.prototype.onEditZoneRecordClick = function (id) {
        this.setState({ edit_mode: "ZONES-EDIT", zoneRecord: id });
    };
    PGwsGameProvidersList.prototype.onGoToZonesListClick = function () {
        this.setState({ edit_mode: "ZONES-LIST", zoneRecord: null });
    };
    PGwsGameProvidersList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(GwsGameProvidersEditor_1.default, { data: this.props.data, state: this.props.state, recordKey: null, onGoBack: this.onGoBackClick.bind(this) }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(GwsGameProvidersEditor_1.default, { data: this.props.data, state: this.props.state, recordKey: this.state.rootRecord, onGoBack: this.onGoBackClick.bind(this) }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(GwsGameProvidersList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onViewGamesClick: this.onVewGamesClick.bind(this), onConfigClick: this.onConfigClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), onAccessConfigClick: this.onAccessConfigClick.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, onZonesClick: this.onVewZonesClick.bind(this) }));
        }
        if (this.state.edit_mode === "CONFIG") {
            return (React.createElement(GwsGameProviderCfgEditor_1.default, { data: this.props.gwsB2bCfg, state: this.props.state, recordKey: this.state.rootRecord, onGoBack: this.onGoBackClick.bind(this), dialogViewText: this.props.dialogViewText }));
        }
        if (this.state.edit_mode === "ACCESS-CONFIG") {
            return (React.createElement(GwsGameProviderAdminsAccessList_1.default, { data: this.props.dataAccess, state: this.props.state, recordKey: this.state.rootRecord, onGoBackClick: this.onGoBackClick.bind(this), dialog: this.props.dialog }));
        }
        if (this.state.edit_mode === "VIEW-GAMES") {
            return (React.createElement(GwsGameProviderGamesList_1.default, { data: this.props.gamesData, state: this.props.state, onGoBack: this.onGoBackClick.bind(this), recordKey: this.state.rootRecord }));
        }
        if (this.state.edit_mode === "ZONES-LIST") {
            return (React.createElement(GwsGameProviderZonesList_1.default, { data: this.props.dataZones, state: this.props.state, onGoBack: this.onGoBackClick.bind(this), recordKey: this.state.rootRecord, onNew: this.onNewZoneRecordClick.bind(this), onEdit: this.onEditZoneRecordClick.bind(this) }));
        }
        if (this.state.edit_mode === "ZONES-NEW") {
            return (React.createElement(GwsGameProviderZonesEditor_1.default, { data: this.props.dataZones, state: this.props.state, onGoBack: this.onGoToZonesListClick.bind(this), zoneRecord: null, rootRecord: this.state.rootRecord }));
        }
        if (this.state.edit_mode === "ZONES-EDIT") {
            return (React.createElement(GwsGameProviderZonesEditor_1.default, { data: this.props.dataZones, state: this.props.state, onGoBack: this.onGoToZonesListClick.bind(this), zoneRecord: this.state.zoneRecord, rootRecord: this.state.rootRecord }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PGwsGameProvidersList.prototype.render = function () {
        return this.getRenderObject();
    };
    PGwsGameProvidersList.getPageDescription = function (state) {
        return {
            icon: "dice",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_gws_gameproviders + "-id",
            itemTitle: "Игры",
            route: routes_1.routes.page_gws_gameproviders,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PGwsGameProvidersList;
}(React.Component));
exports.default = PGwsGameProvidersList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gws_gameproviders_list/ui/PGwsGameProvidersList.tsx
// module id = 1855
// module chunks = 0